module.exports = __webpack_public_path__ + "static/media/Agrocare Marketplace App Over View - GBR Tech - 18-10-2024 C.47613b17.gif";